import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import AddEmailModal from "@/shared/components/channels/AddEmailModal.vue";
import { createOrganisationCommunicationChannel } from "../../infrastructure/api/organisationApi";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrganisationAddEmailModal',
    props: /*@__PURE__*/ _mergeModels({
        organisationId: {},
        hasPrimaryEmail: { type: Boolean }
    }, {
        "modelValue": { type: Boolean, ...{ default: false } },
        "modelModifiers": {},
    }),
    emits: /*@__PURE__*/ _mergeModels(["created"], ["update:modelValue"]),
    setup(__props, { emit: __emit }) {
        const props = __props;
        const open = _useModel(__props, "modelValue");
        const emit = __emit;
        function submitEmail(payload) {
            return createOrganisationCommunicationChannel(props.organisationId, {
                type: "Email",
                value: payload.value,
                isPrimary: payload.isPrimary,
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(AddEmailModal, {
                modelValue: open.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((open).value = $event)),
                "has-primary-email": __props.hasPrimaryEmail,
                "with-context": false,
                submit: submitEmail,
                "i18n-prefix": "organisation.detail.addEmail",
                onCreated: _cache[1] || (_cache[1] = ($event) => (emit('created')))
            }, null, 8 /* PROPS */, ["modelValue", "has-primary-email"]));
        };
    }
});
